import type * as next from '../../../types/next'
import type { BlockUiSchema } from '../../../utils'

export const upCommonSettings = (
  uischema: BlockUiSchema
): next.BlockBaseSettings => {
  const options = uischema.options || {}

  return {
    showPaper: Boolean(uischema.options?.showPaper),
    title: uischema.options?.title,
    subtitle: uischema.options?.subtitle,
    variablePath: uischema.options?.variablePath,
    ...(options.stickyOnMobile && { sticky: options.stickyOnMobile }),
    ...(options.stickyOnMobile && { stickyIndex: options.stickyOnMobileIndex }),
    ...(options.halfWidth && { halfWidth: options.halfWidth })
  }
}

export const nonEmptyStringOrUndefined = (
  value: unknown
): string | undefined => {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}
